// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface endChallengeRequestPayload {
  id: number;
  callback?: Function;
}
export interface endChallengeSuccessPayload {}

export interface endChallengeFailPayload {
  error: Error;
}

export const endChallengeActions = createAsyncAction(
  'elearning/END_CHALLENGE',
  'elearning/END_CHALLENGE_SUCCESS',
  'elearning/END_CHALLENGE_FAIL'
)<
  endChallengeRequestPayload,
  endChallengeSuccessPayload,
  endChallengeFailPayload
>();
